"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bind = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bindClient_1 = require("../../model/bindClient");
var service_1 = require("../../../library/base/service");
var Bind = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Bind, _super);
    function Bind() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '梅赛德斯活动绑定';
        _this.code = '101215';
        _this.desc = '梅赛德斯活动绑定';
        _this.requestParams = new bindClient_1.BindRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Bind;
}(service_1.BaseService));
exports.Bind = Bind;
//# sourceMappingURL=bind.js.map